module.exports = __webpack_public_path__ + "img/white.eb6edf2e.png";